import { CancelToken } from "axios";
import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";

export interface IGetServiceFees {
  facility_id?: number;
  id?: number;
}

interface IPostServiceFee {
  fixed_amount?: number;
  percent?: number;
  type?: string;
}

interface IPutServiceFee {
  fixed_amount?: number;
  percent?: number;
  type?: string;
  title?: string;
  id: number;
  application?: string;
}

interface IDeleteServiceFee {
  id: number;
}

export async function GetServiceFees(params: IGetServiceFees, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/payment/service-fee"), params, useGlobalLoader, token);
}

export async function PostServiceFee(params: IPostServiceFee, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/payment/service-fee"), params, useGlobalLoader);
}

export async function PutServiceFee(params: IPutServiceFee, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/payment/service-fee"), params, useGlobalLoader);
}
export async function DeleteServiceFee(params: IDeleteServiceFee, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/payment/service-fee"), params, useGlobalLoader);
}
